import {Component, Input, OnInit} from '@angular/core';
import {
  MasterSummaryQuestionModel,
} from '../../../../models/survey/survey.model';
import { ChartName } from '../../../../shared/constants/chart.constants';
import {
  allowShowBarchart,
  allowShowPieChart,
  showAverageNumericResponse,
  showMostCommonResponse
} from '../../../../shared/helpers/chart-helper';

@Component({
  selector: 'app-compare-question-table',
  templateUrl: './compare-question-table.component.html',
  styleUrls: ['./compare-question-table.component.less']
})
export class CompareQuestionTableComponent implements OnInit {

  @Input() listQuestionModel: MasterSummaryQuestionModel[];
  @Input() answerType: string;
  @Input() questionName: string;
  @Input() listSurveyName: string[] = [];

  showDropdown = false;
  barChartLabel = ChartName.BAR_CHART;
  roseChartLabel = ChartName.ROSE_CHART;
  averageChartLabel = ChartName.AVERAGE_CHART;
  mostCommonChartLabel = ChartName.MOST_COMMON_CHART;
  
  constructor() {
  }

  ngOnInit() {

  }

  showChart(barChart: boolean) {
    this.listQuestionModel.forEach(s => {
      s.barChart = barChart;
      s.chart = !barChart;
      s.mostCommonResponse = false;
      s.averageResponse = false;
    });
  }

  showAverageNumeric() {
    this.listQuestionModel.forEach(s => {
      s.barChart = false;
      s.chart = false;
      s.mostCommonResponse = false;
      s.averageResponse = true;
    });
  }

  showCommonNumeric() {
    this.listQuestionModel.forEach(s => {
      s.barChart = false;
      s.chart = false;
      s.mostCommonResponse = true;
      s.averageResponse = false;
    });
  }

  allowShowBarChart(type: string): boolean {
    return allowShowBarchart(type);
  }

  allowShowPieChart(type: string): boolean {
    return allowShowPieChart(type);
  }

  showAverageNumericResponse(type: string): boolean {
    return showAverageNumericResponse(type);
  }

  showMostCommonResponse(type: string): boolean {
    return showMostCommonResponse(type);
  }

  onClickOutside(event: Object) {
    if (event && event['value'] === true) {
      this.showDropdown = false;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/routes/surveys/master-summary/compare-question-table/compare-question-table.component.ts